<template>
  <div class="faq-page">
    <div class="container">
      <h1 class="page-title">{{ $t('faq.title') }}</h1>
      
      <div class="faq-container">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.noSms.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <p><strong>{{ $t('faq.questions.noSms.possibleReasons') }}</strong></p>
              <ul>
                <li>{{ $t('faq.questions.noSms.reasons.0') }}</li>
                <li>{{ $t('faq.questions.noSms.reasons.1') }}</li>
                <li>{{ $t('faq.questions.noSms.reasons.2') }}</li>
                <li>{{ $t('faq.questions.noSms.reasons.3') }}</li>
                <li>{{ $t('faq.questions.noSms.reasons.4') }}</li>
                <li>{{ $t('faq.questions.noSms.reasons.5') }}</li>
              </ul>
              <div class="faq-note">
                <strong>{{ $t('common.note') }}：</strong>{{ $t('faq.questions.noSms.note') }}
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item name="2">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.balanceIssue.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <ul>
                <li>{{ $t('faq.questions.balanceIssue.description') }}</li>
                <li>{{ $t('faq.questions.balanceIssue.calculation') }}</li>
              </ul>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="3">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.specifyPhone.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <p>{{ $t('faq.questions.specifyPhone.answer') }}</p>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="4">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.phoneNotFound.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <ul>
                <li>{{ $t('faq.questions.phoneNotFound.reasons.0') }}</li>
                <li>{{ $t('faq.questions.phoneNotFound.reasons.1') }}</li>
              </ul>
              <div class="faq-note">
                <strong>{{ $t('common.tip') }}：</strong>{{ $t('faq.questions.phoneNotFound.tip') }}
              </div>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="5">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.phoneDuration.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <p>{{ $t('faq.questions.phoneDuration.answer') }}</p>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="6">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.projectNotFound.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <ul>
                <li>{{ $t('faq.questions.projectNotFound.reasons.0') }}</li>
                <li>{{ $t('faq.questions.projectNotFound.reasons.1') }}</li>
              </ul>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="7">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.internationalCards.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <p>{{ $t('faq.questions.internationalCards.answer') }}</p>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="8">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.sendSms.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <p>{{ $t('faq.questions.sendSms.answer') }}</p>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="9">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.otherQuestions.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <p>{{ $t('faq.questions.otherQuestions.answer') }}</p>
            </div>
          </el-collapse-item>
          
          <el-collapse-item name="10">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.backupAddress') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <a href="https://www.qc86.shop/" target="_blank" rel="noopener noreferrer" class="faq-link">https://www.qc86.shop/</a>
            </div>
          </el-collapse-item>

          <el-collapse-item name="11">
            <template #title>
              <div class="faq-question">
                <span class="question-icon">Q</span>
                <span>{{ $t('faq.questions.unexpectedCharge.title') }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <ul>
                <li>{{ $t('faq.questions.unexpectedCharge.explanations.0') }}</li>
                <li>{{ $t('faq.questions.unexpectedCharge.explanations.1') }}</li>
                <li>{{ $t('faq.questions.unexpectedCharge.explanations.2') }}</li>
              </ul>
            </div>
          </el-collapse-item>

        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'FAQView',
  setup() {
    const activeNames = ref(['1']) // 默认展开第一个问题
    
    const handleChange = (val) => {
      console.log(val)
    }
    
    return {
      activeNames,
      handleChange
    }
  }
}
</script>

<style scoped>
.faq-page {
  padding: 40px 0 80px;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 40px;
  color: var(--text-primary);
  text-align: center;
}

.faq-container {
  max-width: 800px;
  margin: 0 auto;
  background-color: var(--card-background);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.faq-question {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: var(--text-primary);
  padding: 4px 0;
}

.question-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  font-size: 14px;
  font-weight: 700;
  margin-right: 12px;
}

.faq-answer {
  padding: 8px 0 8px 36px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.faq-answer p {
  margin-bottom: 12px;
}

.faq-answer ul {
  padding-left: 20px;
  margin-bottom: 16px;
}

.faq-answer li {
  margin-bottom: 8px;
}

.faq-note {
  background-color: rgba(255, 193, 7, 0.1);
  border-left: 3px solid #FFC107;
  padding: 12px 16px;
  border-radius: var(--radius-sm);
  margin-top: 12px;
}

.faq-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

.faq-link:hover {
  text-decoration: underline;
}

/* 调整 Element Plus 折叠面板样式 */
:deep(.el-collapse) {
  border-top: none;
  border-bottom: none;
}

:deep(.el-collapse-item__header) {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
}

:deep(.el-collapse-item__content) {
  padding: 16px 20px;
  background-color: var(--hover-color);
}

:deep(.el-collapse-item:last-child .el-collapse-item__header) {
  border-bottom: none;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 28px;
    margin-bottom: 30px;
  }
  
  .faq-container {
    border-radius: var(--radius-md);
  }
  
  :deep(.el-collapse-item__header) {
    padding: 14px 16px;
  }
  
  :deep(.el-collapse-item__content) {
    padding: 14px 16px;
  }
}
</style> 